import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface PricingSectionGroupProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
  testId?: string;
  variant?: "default" | "emphasis";
}

export function PricingSectionGroup({
  title,
  description,
  children,
  className,
  testId,
  variant = "default",
}: PricingSectionGroupProps) {
  return (
    <section
      data-testid={testId}
      className={cn(
        "border border-primary-200 dark:border-primary-800 p-6 space-y-4",
        variant === "emphasis" && "bg-primary-100/60 dark:bg-primary-900/40",
        className
      )}
    >
      <div className="space-y-1">
        <h3 className="text-xs font-light tracking-widest uppercase text-primary-600 dark:text-primary-400">
          {title}
        </h3>
        {description ? (
          <p className="text-sm font-light text-primary-600 dark:text-primary-400">{description}</p>
        ) : null}
      </div>
      {children}
    </section>
  );
}
